import { AboutFactStrip } from '@/features/company-pages/components/AboutFactStrip'
import {
  ProseAnchor,
  ProseHeading,
  ProseLink,
  ProseParagraph,
} from '@/features/company-pages/components/ReadingProse'
import { CONTACT_EMAIL } from '@/lib/constants'
import { Reveal } from '@/shared/components/Reveal'

const FACTS = [
  { label: 'Founded', value: '2026' },
  { label: 'Legal entity', value: 'ModelStack Inc.' },
  { label: 'Contact', value: CONTACT_EMAIL },
]

/** The About page's reading column: what we do, company facts, contact. */
export function AboutBody() {
  return (
    <section className="w-full px-6 pb-24 md:pb-36">
      <div className="mx-auto max-w-6xl border-t border-[var(--color-border)] pt-16 md:pt-20">
        <div className="max-w-3xl space-y-20">
          <Reveal>
            <ProseHeading>What we do</ProseHeading>
            <div className="space-y-4">
              <ProseParagraph>
                Every request routes through{' '}
                <ProseLink to="/provider-tiers">
                  economy, standard, and premium provider tiers
                </ProseLink>
                , so you can trade cost against latency and reliability per call
                without rewriting integration code when you switch models or
                providers.
              </ProseParagraph>
              <ProseParagraph>
                <ProseLink to="/agents">Agent teams</ProseLink> put a
                coordinator model and the specialists it can call behind one
                model id, so escalating to a stronger model happens per request
                instead of per application.
              </ProseParagraph>
              <ProseParagraph>
                We run a zero-log policy on request content — see the{' '}
                <ProseLink to="/privacy">Privacy Policy</ProseLink> for the
                specifics of what we do and don't retain.
              </ProseParagraph>
            </div>
          </Reveal>

          <Reveal>
            <ProseHeading>The company</ProseHeading>
            <AboutFactStrip facts={FACTS} />
          </Reveal>

          <Reveal>
            <ProseHeading>Get in touch</ProseHeading>
            <ProseParagraph>
              Questions, partnership requests, or press inquiries: reach us at{' '}
              <ProseAnchor href={`mailto:${CONTACT_EMAIL}`}>
                {CONTACT_EMAIL}
              </ProseAnchor>
              , or see the <ProseLink to="/support">Support</ProseLink> page for
              our Telegram and Discord channels.
            </ProseParagraph>
          </Reveal>
        </div>
      </div>
    </section>
  )
}
